import { MacroEventType } from '../deviceProfiles/MacroEvent';

export interface MacroStepRule {
    eventType: MacroEventType;
    key?: string;
    maximumUsePerMacro?: number;
    deviceTypeCustomActionId?: string;
    maximumHoldTimeMilliseconds?: number;
    disableLatching: boolean;
}

export default interface DeviceTypeThrottleRules {
    disableVoiceInput: boolean;
    disableHotkeyInput: boolean;
    disableCameraInput: boolean;
    disableMultiInputs: boolean;
    maximumCommandsPerSecond?: number;
    maximumCommandsPerMinute?: number;
    maximumMacroLength?: number;
    macroStepRules?: MacroStepRule[];
}

export const getDefaultThrottleRules = (): DeviceTypeThrottleRules => ({
    disableVoiceInput: false,
    disableHotkeyInput: false,
    disableCameraInput: false,
    disableMultiInputs: false,
    maximumCommandsPerSecond: undefined,
    maximumCommandsPerMinute: undefined,
    maximumMacroLength: undefined,
    macroStepRules: undefined,
});
